module.exports = __webpack_public_path__ + "static/360connect-d9511b6c26521fbffc8e2cac95a1ec9f.png";